import React, { Component } from 'react';
import Vas from '../Vas';
import { LinkButton } from 'component-lib';

class ActivateEMailSuccessOffline extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {};
  }

  render()
  {
    
    return ( <div className="LoginContainer">
      <div 
        className={"form"} 
        style={{ width:'400px' }}>
        <table>
          <thead>
            <tr>
              <th colSpan={2}><h2>{Vas.Resources.Labels["ActivateEmail"]}</h2></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ width:'102px', fontSize:'14px' }}>{Vas.Resources.Labels["LinkLogin"]}</td>
              <td><LinkButton 
                Text={Vas.Resources.Menus["Login"]} 
                Id={"LinkLogin"} 
                OnClick={()=>{Vas.GetView("Login",null,false);}}
              />
              </td>
            </tr>
          </tbody>
        </table> 
      </div>
    </div>);
  }
}
export default ActivateEMailSuccessOffline;
